module.exports = __webpack_public_path__ + "img/48.c62f1009.png";